import React from "react";
import Reveal from "./Reveal";
import { TEAM } from "../../content/site";
import { useLanguage } from "../../i18n/LanguageContext";

// Who's behind the studio: one card per person, the illustrated avatar beside
// name, role (current language first, the other beside it), bio, and a short
// label/value list. Cards share hairlines so the pair reads as one instrument
// panel. Sits between the work index and contact.
function MemberCard({ member, index }) {
  const { lang, t } = useLanguage();
  const otherLang = lang === "en" ? "ja" : "en";

  return (
    <Reveal as="article" className="dp-team__card" delay={80 + index * 90}>
      <img
        className="dp-team__portrait"
        src={member.avatar}
        alt={t(member.avatarAlt)}
        loading="lazy"
        draggable="false"
      />
      <div className="dp-team__body">
        <h3 className="dp-team__name">{member.name}</h3>
        <p className="dp-team__role">
          <span>{member.role[lang]}</span>
          <span className="dp-team__role-alt" lang={otherLang}>
            {member.role[otherLang]}
          </span>
        </p>
        {member.bio.map((line) => (
          <p key={line.en} className="dp-team__bio">
            {t(line)}
          </p>
        ))}
        <dl className="dp-team__details">
          {member.details.map((row) => (
            <React.Fragment key={row.label.en}>
              <dt>{t(row.label)}</dt>
              <dd>
                {row.href ? (
                  <a href={row.href} target="_blank" rel="noreferrer noopener">
                    {t(row.value)}
                    <span aria-hidden="true"> ↗</span>
                  </a>
                ) : (
                  t(row.value)
                )}
              </dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </Reveal>
  );
}

export default function Team() {
  const { t } = useLanguage();
  const eyebrow = t(TEAM.eyebrow);

  return (
    <section id="team" className="dp-section dp-team" aria-label={eyebrow}>
      <Reveal as="h2" className="dp-eyebrow">
        {eyebrow}
      </Reveal>
      <div className="dp-team__grid">
        {TEAM.members.map((member, i) => (
          <MemberCard key={member.name} member={member} index={i} />
        ))}
      </div>
    </section>
  );
}
